import { editPassword } from '@/services/common';
import { BetaSchemaForm } from '@ant-design/pro-components';
import type { ProFormColumnsType } from '@ant-design/pro-form/es/components/SchemaForm/typing.d.ts';
import { message, ModalProps } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { flushSync } from 'react-dom';
import { history, useModel } from '@umijs/max';
import { removeItem } from '@/utils';
import {
  AUTO_LOGIN_STORIGE_KEY,
  REFRESH_TOKEN_STORIGE_KEY,
  TOKEN_STORIGE_KEY,
  TOKEN_TYPE,
} from '@/constants';

export type EditPassWordModalRef = {
  open: () => void;
};

const EditPassWordModal = forwardRef<EditPassWordModalRef, any>((props, ref) => {
  const [open, setOpen] = useState(false);
  const [form] = useForm();
  const { setInitialState, initialState } = useModel('@@initialState');
  useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true);
    },
  }));
  const modalProps: ModalProps = {
    className: 'BetaSchemaFormModal',
    onClose: () => setOpen(false),
    onCancel: () => setOpen(false),
    maskClosable: false,
    destroyOnClose: true,
    forceRender: true,
  };

  const onFinish = async (values: any) => {
    const res = await editPassword(initialState?.userInfo?.id, values);
    if (res.code === 200) {
      message.success('修改成功');
      setOpen(false);
      flushSync(() => {
        removeItem(TOKEN_TYPE);
        removeItem(TOKEN_STORIGE_KEY);
        removeItem(AUTO_LOGIN_STORIGE_KEY);
        removeItem(REFRESH_TOKEN_STORIGE_KEY);
        setInitialState((s) => ({ ...s, userInfo: undefined, roleInfo: undefined }));
      });
      history.push('/login');
      return;
    }
  };

  const columns: ProFormColumnsType[] = [
    // {
    //   title: '原密码',
    //   valueType: 'password',
    //   dataIndex: 'old_password',
    //   fieldProps: { maxLength: 20 },
    //   formItemProps: { rules: [{ required: true }] },
    // },
    {
      title: '新密码',
      valueType: 'password',
      dataIndex: 'password',
      fieldProps: { maxLength: 20 },

      formItemProps: {
        validateFirst: true,
        rules: [
          { required: true },
          {
            validator(_, value) {
              if (value.length < 6) {
                return Promise.reject('密码长度至少6位');
              }
              return Promise.resolve();
            },
          },
        ],
      },
    },
    {
      title: '新密码确认',
      valueType: 'password',
      dataIndex: 'password2',
      fieldProps: { maxLength: 20 },
      formItemProps: {
        dependencies: ['password'],
        validateFirst: true,
        rules: [
          {
            required: true,
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('密码不一致'));
            },
          }),
        ],
      },
    },
  ];

  return (
    <BetaSchemaForm
      title="修改密码"
      form={form}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 10 }}
      layout="horizontal"
      open={open}
      columns={columns}
      layoutType="ModalForm"
      modalProps={modalProps}
      onFinish={onFinish}
      {...(props as any)}
    />
  );
});

export default EditPassWordModal;
